/// <reference types="facebook-js-sdk" />
import { Head } from '@infl-ts/ui-advocate-components';
import { useEffect } from 'react';
import { FACEBOOK_APP_ID } from '../../../../env';
import { jsx as _jsx } from "react/jsx-runtime";

var FacebookScripts = function FacebookScripts() {
  useEffect(function () {
    if (!window.fbAsyncInit) {
      window.fbAsyncInit = function () {
        FB.init({
          version: 'v12.0',
          appId: FACEBOOK_APP_ID,
          status: true,
          cookie: true,
          xfbml: true
        });
      };
    }
  }, []);
  return /*#__PURE__*/_jsx(Head, {
    "data-element": "Head",
    "data-component": "FacebookScripts",
    "data-source-file": "facebook-scripts.tsx",
    children: /*#__PURE__*/_jsx("script", {
      crossOrigin: "anonymous",
      src: "https://connect.facebook.net/en_US/sdk.js",
      "data-component": "FacebookScripts",
      "data-source-file": "facebook-scripts.tsx"
    })
  });
};

export default FacebookScripts;